// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-license-box--maxwidth {
  max-width: 600px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/UploadLicense/styles/UploadLicense.css","webpack://./services/frontend/app/pages/UploadLicense/styles/UploadLicense.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".upload-license-box--maxwidth {\n  margin: 0 auto;\n  max-width: 600px;\n}\n",".upload-license-box--maxwidth {\n  max-width: 600px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
